"use strict";

const css = require("js/css_constants");
const utils = require("js/util");
const $ = require("jquery");
const tracker = require("js/utils/focus_tracker");

let control = null;

/*
 * We need to use _two_ different containers here, because of different behaviour required by different
 * content:
 *
 * Some of the content in the popups is provided by JS only, which can trigger bugs if the same modal container
 * is being used by a LiveView which can remove and add childs without JS interaction. For that content
 * (which should be the majority of the content), the popup container should be a sibling to the main LiveView.
 *
 * However some other controls insert popup content that is controlled by sub LiveViews, like the search popup.
 * Here it is required that the content of the sub LiveView lives as a child of the content of the main LiveView,
 * otherwiese joining the sub LibeView does not work correctly, and it's events will eb forwareded to the main
 * LiveView, triggering bugs where no handle_event() clause matches. For these cases, __always__ use the
 * container for LiveView.
 *
 * To control which container is being used, pass the correct option to the the show function.
 */
function init(containerSelector, containerSelectorForLiveViews) {
    const container = document.querySelector(containerSelector);
    const containerForLiveViews = document.querySelector(containerSelectorForLiveViews);
    let popup = null;

    /**
     * Close the popup when escape key is pressed.
     */
    document.addEventListener("keydown", (event) => {
        if (event.key == "Escape") {
            if (popup != null) {
                console.log("Close popup ESC key pressed.");
                hide();
            }
        }
    });

    /*
     * Show some content as a modal popup.
     *
     * The function will make sure that no two modal popups can be shown at the same time.
     *
     * By default you should try to use the normal modal container, not the one for LiveViews.
     *
     * If your contnet is a sub LiveView of the main LiveView, pass the useLiveViewContainer = true
     * option to this function.
     */
    function show(content, toFocus, opts = {}) {
        const { useLiveViewContainer = false } = opts;

        if (popup != null) {
            throw new Error("Cannot show popup, already showing one");
        }

        popup = document.createElement("div");
        popup.classList.add("popup");
        popup.classList.add("popup-centered");
        popup.classList.add("rounded");
        popup.classList.add("wider-popup");

        popup.appendChild(content);

        // always remove from both containers if they exist
        if (container) {
            utils.removeAllChildren(container);
        }
        if (containerForLiveViews) {
            utils.removeAllChildren(containerForLiveViews);
        }

        if (useLiveViewContainer && containerForLiveViews) {
            containerForLiveViews.appendChild(popup);
            containerForLiveViews.classList.remove(css.disabled);
        } else if (container) {
            container.appendChild(popup);
            container.classList.remove(css.disabled);
        } else {
            console.error("No modal container found in DOM to display popup");
            popup = null;
            return;
        }

        setTimeout(() => {
            tracker.focusOn(popup);
            // wait sometime before requesting the focus, because for the export
            // card dialog, the focues field is the name selector, which will position
            // the popup, which will overlap the input field if the container has not
            // yet been rendered
            if (toFocus != null) {
                toFocus.focus();
            }
        }, 50);
    }

    function hide() {
        if (container) {
            container.classList.add(css.disabled);
        }
        if (containerForLiveViews) {
            containerForLiveViews.classList.add(css.disabled);
        }
        popup = null;
    }

    control = {
        show: show,
        hide: hide,
    };
}

function getFunction(name) {
    return (...args) => {
        if (control == null) {
            throw "This control must be initialised before first usage!";
        } else {
            control[name].apply(this, args);
        }
    };
}

module.exports.init = init;
module.exports.show = getFunction("show");
module.exports.hide = getFunction("hide");
